
import { RequestedOrderlineMetricTypes } from '@/ConstValues';
import { ConversionHelper } from '@/helpers/ConversionHelper';
import { SetSnackBar } from '@/helpers/SnackbarHelper';
import { OrdersService } from '@/services/orders-service';
import { OrderlineDetails } from '@/store/models/OrderlineModel';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import MaxQuantityPerRoll from '@/components/MaxQuantityPerRoll.vue';
import HandAppliedMaximumRolls from '@/components/HandAppliedMaximumRolls.vue';
import { NumberValueToken } from 'html2canvas/dist/types/css/syntax/tokenizer';
import { QuickDialog } from '@/store/models/DialogModel';
import DialogLayout from '@/components/DialogLayout.vue';

@Component({
  components: {
    MaxQuantityPerRoll,
    HandAppliedMaximumRolls,
    DialogLayout
  }
})
export default class OrderEditRollSpecifications extends Vue {
  /* Properties */
  activeGroupIndex: number = -1;

  /* Store Actions */
  /* Watchers */
  /* Data */
  dialogLayoutData: QuickDialog = new QuickDialog();
  dialog: boolean = false;
  orderline: OrderlineDetails = new OrderlineDetails();
  canSubmitMaxQtyPerRoll = false;
  canSubmitHandApplied = false;
  quantityRollsAndLabels: { Rolls: number; Labels: number } = { Rolls: 0, Labels: 0 };
  rollSpecificationOptions: any[] = [
    {
      action: 'mdi-hand-back-left',
      active: true,
      items: [{ title: '' }],
      title: 'Hand Applied - Maximum Rolls',
      subtitle: 'The more rolls, the better!',
      OrderlineMetricType: RequestedOrderlineMetricTypes.RollQuantity
    },
    {
      action: 'mdi-circle-multiple',
      active: true,
      items: [{ title: '' }],
      title: 'Maximum Quantity Per Roll',
      subtitle: 'Lower quantity will amount to more rolls',
      OrderlineMetricType: RequestedOrderlineMetricTypes.MaxLabelsPerRoll
    }
  ];

  @Watch('activeGroupIndex')
  onActiveGroupChange(newIndex: number) {
    // Update active states in options
    this.rollSpecificationOptions = this.rollSpecificationOptions.map((option, idx) => ({
      ...option,
      active: idx === newIndex
    }));
  }

  /* Computed */
  get currentOpenGroup(): string {
    return this.activeGroup?.title || undefined;
  }

  get activeGroup() {
    return this.activeGroupIndex >= 0 ? this.rollSpecificationOptions[this.activeGroupIndex] : null;
  }

  get isFirstGroupOpen(): boolean {
    return this.activeGroupIndex === 0;
  }
  set isFirstGroupOpen(value: boolean) {
    if (value) {
      this.activeGroupIndex = 0;
    } else if (this.activeGroupIndex === 0) {
      this.activeGroupIndex = -1;
    }
  }

  get isSecondGroupOpen(): boolean {
    return this.activeGroupIndex === 1;
  }
  set isSecondGroupOpen(value: boolean) {
    if (value) {
      this.activeGroupIndex = 1;
    } else if (this.activeGroupIndex === 1) {
      this.activeGroupIndex = -1;
    }
  }

  get isGroupActive(): boolean {
    return this.activeGroupIndex >= 0;
  }

  /* Async Functions */
  /* Utility Functions */
  async openDialog(orderline: OrderlineDetails) {
    this.orderline = orderline;
    this.dialogLayoutData = ConversionHelper.convertOrderlineToDialogLayout(this.orderline);
    this.dialog = true;
  }
  closeDialog() {
    this.dialog = false;
  }

  canSubmit() {
    if (this.currentOpenGroup == undefined) return false;
    if (this.isFirstGroupOpen) return this.canSubmitHandApplied;
    if (this.isSecondGroupOpen) return this.canSubmitMaxQtyPerRoll;
    return true;
  }

  changeRollSpecifications() {
    this.setValues();
    this.$nextTick(() => {
      this.$emit('changeRollSpecifications', this.orderline);
    });
    this.closeDialog();
  }
  setValues() {
    const activeOption = this.activeGroup;
    if (!activeOption) return;
    this.orderline.RequestedOrderlineMetricType = activeOption.OrderlineMetricType;
    switch (activeOption.OrderlineMetricType) {
      case RequestedOrderlineMetricTypes.RollQuantity: {
        const rollQuantity = this.quantityRollsAndLabels.Rolls;
        if (isNaN(rollQuantity)) {
          this.orderline.RequestedRollQuantity = this.orderline.GeneratedRollQuantity;
        } else {
          this.orderline.RequestedMaxLabelQuantity = Math.ceil(this.quantityRollsAndLabels.Labels);
          this.orderline.RequestedRollQuantity = rollQuantity;
        }
        return;
      }
      case RequestedOrderlineMetricTypes.MaxLabelsPerRoll: {
        this.orderline.RequestedMaxLabelQuantity = this.quantityRollsAndLabels.Labels;
        this.orderline.RequestedRollQuantity = this.quantityRollsAndLabels.Rolls;
        return;
      }
    }
  }
  /* Loaders */

  /* Mounted */
  mounted() {
    // Initialize with no group open
    this.activeGroupIndex = -1;
    // Reset active states
    this.rollSpecificationOptions = this.rollSpecificationOptions.map(option => ({
      ...option,
      active: false
    }));
  }
  /* Created */
  /* Emmited Functions */
}
